// Shim per regenerator-runtime in contesti con CSP senza 'unsafe-eval'.
// La libreria, se non trova il globale, usa Function("r", "regeneratorRuntime = r")
// come fallback: con la CSP attiva quel fallback viene bloccato e interrompe il bundle.
// Definendo il globale prima che il modulo venga valutato, il fallback non viene usato.
if (typeof window !== 'undefined' && !window.regeneratorRuntime) {
	window.regeneratorRuntime = {};
}
